import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import Modal from '../../../../common/modal/Modal';
import {
  generateRescueItineraryPath,
  NEW_SERVICE_MERGE_PATH,
} from '../../../../../config/paths';

export const CloseServiceButton = ({ itineraryId }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const [reason, setReason] = useState('');

  const FUSION_URL = (id) =>
    `${NEW_SERVICE_MERGE_PATH}?sourceItineraryId=${id}`;

  const openModal = () => {
    setReason('');
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const handleContinue = () => {
    if (reason === 'commercial') {
      window.location.assign(FUSION_URL(itineraryId));
      return;
    }

    if (reason === 'mechanic') {
      window.location.assign(generateRescueItineraryPath(itineraryId));
    }
  };

  const buildModalBody = () => {
    const newModalBody = (
      <div>
        <p style={{ marginBottom: 16 }}>
          Seleccione el motivo del <strong>cierre de servicio</strong>. Según la
          opción elegida, el sistema lo redirigirá al flujo correspondiente.
        </p>

        <FormGroup>
          <Label for="closeServiceReason">Motivo del cierre</Label>
          <Input
            type="select"
            id="closeServiceReason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          >
            <option value="" disabled>
              Seleccione una opción
            </option>
            <option value="commercial">Comercial</option>
            <option value="mechanic">Mecánico</option>
          </Input>
        </FormGroup>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button color="secondary" onClick={closeModal}>
            Cancelar
          </Button>

          <Button color="primary" disabled={!reason} onClick={handleContinue}>
            Continuar
          </Button>
        </div>
      </div>
    );

    setModalBody(newModalBody);
  };

  useEffect(() => {
    if (showModal !== false) buildModalBody();
  }, [showModal, reason]);

  return (
    <>
      <Modal
        show={showModal}
        title="Cierre de Servicio"
        body={modalBody}
        size="md"
        onClickCancel={closeModal}
        onClickClose={closeModal}
      />

      <Button color="secondary" className="border" onClick={openModal}>
        <i className="fa fa-check-square-o" /> Cierre de Servicio
      </Button>
    </>
  );
};

CloseServiceButton.propTypes = {
  itineraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default CloseServiceButton;
